import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

//const API_URL = "https://api.bizlingerwatershop.co.kr";
const API_URL = "https://api.bizlingerwateradmin.co.kr";

const TokenPage = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [accessToken, setAccessToken] = useState(null);
  const [authCode, setAuthCode] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get("code");
    const state = urlParams.get("state");

    if (!code) {
      setError("인증코드가 없습니다. OAuth 인증을 다시 시도해주세요.");
      return;
    }

    // state에서 mall_id 추출
    let mall_id = null;
    try {
      const stateData = JSON.parse(atob(state));
      mall_id = stateData.mall_id;
      console.log("State에서 추출한 mall_id:", mall_id);
    } catch (error) {
      console.error("State 파싱 오류:", error);
      setError(
        "인증 상태 정보가 올바르지 않습니다. 처음부터 다시 시도해주세요."
      );
      return;
    }

    if (!mall_id) {
      setError("몰 ID 정보가 없습니다. 인증을 다시 시도해주세요.");
      return;
    }

    setAuthCode({ code, state, mall_id });

    // 자동으로 토큰 발급 요청
    setTimeout(() => {
      requestAccessToken({ code, state, mall_id });
    }, 0);
  }, []);

  const requestAccessToken = async (params) => {
    setLoading(true);
    setError(null);

    try {
      const LAMBDA_API_URL = `${API_URL}/access-token/`;

      const response = await fetch(LAMBDA_API_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          code: params.code,
          state: params.state,
          mall_id: params.mall_id,
        }),
      });

      if (!response.ok) {
        const errorData = await response.text();
        console.log("response", response);
        throw new Error(`Lambda 서버 오류 (${response.status}): ${errorData}`);
      }

      const data = await response.json();

      console.log("data:", data);

      if (data.result.access_token) {
        setAccessToken(data.result.access_token);
        localStorage.setItem("cafe24_access_token", data.result.access_token);
        localStorage.setItem("cafe24_mall_id", params.mall_id);
        console.log("Access token 발급 성공:", data.result.access_token);

        // 즉시 메인페이지로 이동
        setTimeout(() => {
          navigate("/main");
        }, 0);
      } else {
        throw new Error("Lambda 서버에서 access_token을 반환하지 않았습니다.");
      }
    } catch (err) {
      setError(err.message);
      console.error("Lambda 서버 Access token 요청 실패:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        textAlign: "center",
        padding: "40px",
        minHeight: "100vh",
        backgroundColor: "#f8f9fa",
      }}
    >
      {error && (
        <div
          style={{
            background: "#f8d7da",
            padding: "25px",
            borderRadius: "10px",
            border: "1px solid #f5c6cb",
            color: "#721c24",
          }}
        >
          <h3>❌ 토큰 발급 실패</h3>
          <p style={{ margin: "15px 0" }}>{error}</p>
          <button
            onClick={() => navigate("/")}
            style={{
              padding: "10px 20px",
              backgroundColor: "#dc3545",
              color: "white",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
              fontSize: "14px",
            }}
          >
            처음부터 다시 시작
          </button>
        </div>
      )}
      {/* <h1 style={{ fontSize: "2.5rem", marginBottom: "30px", color: "#333" }}>
        🔑 Access Token 발급
      </h1>

      <div
        style={{
          background: "white",
          padding: "30px",
          borderRadius: "15px",
          boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
          maxWidth: "600px",
          margin: "0 auto",
        }}
      >
        {loading && (
          <div>
            <h3>🔄 Access Token을 발급받는 중입니다...</h3>
            <div style={{ margin: "30px 0" }}>
              <div
                style={{
                  width: "60px",
                  height: "60px",
                  border: "6px solid #f3f3f3",
                  borderTop: "6px solid #28a745",
                  borderRadius: "50%",
                  animation: "spin 1s linear infinite",
                  margin: "0 auto",
                }}
              ></div>
            </div>
            {authCode && (
              <div
                style={{ fontSize: "14px", color: "#666", marginTop: "20px" }}
              >
                <p>인증코드: {authCode.code.substring(0, 20)}...</p>
                <p>몰 ID: {authCode.mall_id}</p>
              </div>
            )}
          </div>
        )}

        {accessToken && (
          <div
            style={{
              background: "#d4edda",
              padding: "25px",
              borderRadius: "10px",
              border: "1px solid #c3e6cb",
            }}
          >
            <h3>✅ Access Token 발급 완료!</h3>
            <p style={{ margin: "15px 0" }}>
              인증이 성공적으로 완료되었습니다.
            </p>
            <div
              style={{
                background: "#f8f9fa",
                padding: "15px",
                borderRadius: "5px",
                margin: "20px 0",
                wordBreak: "break-all",
                fontSize: "12px",
                fontFamily: "monospace",
                maxHeight: "100px",
                overflow: "auto",
              }}
            >
              {accessToken}
            </div>
            <div
              style={{
                background: "#cce5ff",
                padding: "10px",
                borderRadius: "5px",
                fontSize: "14px",
                color: "#004085",
              }}
            >
              🚀 3초 후 메인페이지로 이동합니다...
            </div>
          </div>
        )}

        {error && (
          <div
            style={{
              background: "#f8d7da",
              padding: "25px",
              borderRadius: "10px",
              border: "1px solid #f5c6cb",
              color: "#721c24",
            }}
          >
            <h3>❌ 토큰 발급 실패</h3>
            <p style={{ margin: "15px 0" }}>{error}</p>
            <button
              onClick={() => navigate("/")}
              style={{
                padding: "10px 20px",
                backgroundColor: "#dc3545",
                color: "white",
                border: "none",
                borderRadius: "5px",
                cursor: "pointer",
                fontSize: "14px",
              }}
            >
              처음부터 다시 시작
            </button>
          </div>
        )}
      </div> */}
    </div>
  );
};

export default TokenPage;
